export default () => [
  <path d="M22 17.37a3.33 3.33 0 0 1-2.14 3.1c-.35.13-.72.2-1.1.2h-8.51a1.38 1.38 0 0 1-1.28-1.89l.23-.37 1.14-1.83h5.29v-.01a1 1 0 0 0 .73-1.41v-.03a1.37 1.37 0 0 0-.13-.18l-1.8-2.76a2 2 0 0 1-.03-2.16l1.67-2.7h.01l5.32 8.12.1.15c.32.53.5 1.14.5 1.76Zm-7.73-12.8a2.11 2.11 0 0 1 .03 2.27L5.72 20.67H1L12.59 2l1.68 2.57Z" />,
];
